"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _TermsDialog = _interopRequireDefault(require("./TermsDialog"));

var _AppStore = _interopRequireDefault(require("../Store/AppStore"));

var _mobxReact = require("mobx-react");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    formControl: {
      width: "100%",
      margin: theme.spacing(1)
    },
    root: {
      maxWidth: 550,
      padding: theme.spacing(2)
    },
    label: {
      marginLeft: 0,
      textAlign: "left"
    }
  };
});

var AccountSelectPage = function AccountSelectPage() {
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTerms = _useState2[0],
      setShowTerms = _useState2[1];

  if (_AppStore.default.loadingAccounts) {
    return /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null);
  }

  if (!_AppStore.default.accounts || _AppStore.default.accounts.length === 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h5"
    }, "Oops!"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, null, "It looks like you don\u2019t have billing access to any accounts."), /*#__PURE__*/_react.default.createElement(_core.Typography, null, "Please contact us to request access."));
  }

  if (!_AppStore.default.onlinePaymentTerms || _AppStore.default.onlinePaymentTerms.length === 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6"
    }, "Online Payment Portal Setup Not Complete!"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, null, "Online Payment Terms of Service need to be configured by the office in the MacPractice Admin Portal on the MacPractice Server."));
  }
  /**
   *Get component to display account (if only 1 available), or select account
   *
   * @returns component for selecting/displaying account
   */


  var accountSelect = function accountSelect() {
    if (_AppStore.default.accounts.length === 1) {
      return /*#__PURE__*/_react.default.createElement(_core.TextField, {
        label: "Account",
        className: classes.formControl,
        variant: "outlined",
        disabled: true,
        value: _AppStore.default.accounts[0].displayName
      });
    }

    return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
      variant: "outlined",
      className: classes.formControl
    }, /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
      id: "account-select-label"
    }, "Account"), /*#__PURE__*/_react.default.createElement(_core.Select, {
      labelId: "account-select-label",
      id: "account-select",
      value: _AppStore.default.selectedAccount.accountId,
      onChange: function onChange(e) {
        return _AppStore.default.selectAccount(e.target.value);
      },
      label: "Account",
      style: {
        textAlign: "start"
      }
    }, _AppStore.default.accounts.map(function (account, idx) {
      return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
        key: idx,
        value: account.accountId
      }, account.displayName);
    })));
  };

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, accountSelect()), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    required: true,
    className: classes.formControl,
    label: "Payment Amount",
    variant: "outlined",
    id: "amount-input",
    customInput: _core.TextField,
    thousandSeparator: true,
    isNumericString: true,
    prefix: "$",
    decimalScale: 2,
    fixedDecimalScale: true,
    allowNegative: false,
    value: _AppStore.default.paymentAmount,
    onValueChange: function onValueChange(values) {
      _AppStore.default.setPaymentAmount(values.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    className: classes.label,
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: _AppStore.default.userAcceptedTerms,
      onChange: function onChange(e) {
        return _AppStore.default.markUserTermsAgreement(e.target.checked);
      },
      color: "primary"
    }),
    label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, null, "I have read and agree to the", " ", /*#__PURE__*/_react.default.createElement(_core.Link, {
      href: "#",
      onClick: function onClick() {
        return setShowTerms(true);
      }
    }, "Online Payment Terms of Service")), _AppStore.default.onlinePaymentTermsLastUpdated && /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "caption"
    }, "Last Updated", " ", _AppStore.default.onlinePaymentTermsLastUpdated.toLocaleDateString()))
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.formControl,
    variant: "contained",
    color: "primary",
    component: _reactRouterDom.Link,
    to: "/paymentMethod" //Enable next page button if there is an amount and the user agreement has been accepted
    ,
    disabled: !_AppStore.default.userAcceptedTerms || !_AppStore.default.paymentAmount
  }, "Next")), /*#__PURE__*/_react.default.createElement(_TermsDialog.default, {
    open: showTerms,
    terms: _AppStore.default.onlinePaymentTerms,
    handleClose: function handleClose() {
      return setShowTerms(false);
    },
    handleAccept: function handleAccept() {
      _AppStore.default.markUserTermsAgreement(true);

      setShowTerms(false);
    }
  }));
};

var _default = (0, _mobxReact.observer)(AccountSelectPage);

exports.default = _default;